import { safeSessionStorage } from "~/utils/safeStorage";
import { Api } from "../../api";

export const getDeliveryList = (Redis = false, reset = false) => {
  return async (dispatch) => {
    const response = await Api.cart.getDeliveryList(Redis, reset);
    dispatch({ type: "SET_DELIVERY_LIST", payload: response || [] });
  };
};

export const setDeliveryListAdditional = (list) => {
  return async (dispatch) => {
    dispatch({ type: "SET_DELIVERY_LIST_ADDITIONAL", payload: list });
    dispatch({ type: "SET_DELIVERY_LIST_ADDITIONAL_LOADED", payload: true });
  };
};

export const setStep = (step) => {
  return async (dispatch, getState) => {
    const { cart } = getState();
    if (step > cart.step) {
      dispatch({ type: "SET_ANIMATION", payload: "next" });
    } else {
      dispatch({ type: "SET_ANIMATION", payload: "prev" });
    }

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });
    safeSessionStorage.setItem("cartStep", JSON.stringify(step));
    dispatch({ type: "SET_STEP", payload: step });
    safeSessionStorage.setItem("step", step);
    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });
    dispatch({ type: "SET_ANIMATION", payload: "" });
  };
};
